<template>
  <dx-tree-list
    id="mped-report-results-tree-list"
    class="flex-grow-1"
    height="50px"
    width="100%"
    ref="treeListRef"
    column-resizing-mode="widget"
    filter-mode="fullBranch"
    parentIdExpr="parent_id"
    :data-source="dataSource"
    :columns="columns"
    :header-filter="{ visible: true }"
    :filter-panel="{ visible: true }"
    :filter-row="{ visible: true }"
    :allow-column-resizing="true"
    :hover-state-enabled="true"
    :show-column-lines="true"
    :show-row-lines="true"
    :show-borders="true"
    :column-min-width="70"
    :column-chooser="{ enabled: true, mode: 'select' }"
    @toolbar-preparing="onToolbarPreparing($event)"
    @content-ready="onContentReady($event)"
    @cell-prepared="onCellPrepared($event)"
  >
    <dx-load-panel :enabled="true"/>
    <dx-scrolling mode="virtual"/>
    <dx-sorting mode="single"/>
    <dx-selection mode="single" />
    <template #filterFirstTemplate>
      <div class="mr-4">
        <span>Год:</span>
        <dx-select-box
          class="mb-2"
          v-model="filter.year"
          :data-source="yearDataSource"
          width="100%"
          :showClearButton="false"
          @valueChanged="changeValueAndFilter()"
        />
        <span>План/факт:</span>
        <dx-select-box
          v-model="filter.plFactId"
          :data-source="plFactIdRadio"
          width="100%"
          value-expr="id"
          display-expr="name"
          :showClearButton="false"
          @valueChanged="changeVisibleColumns()"
        />
      </div>
    </template>
    <template #filterSecondTemplate>
      <div class="mr-4">
        <span>Месяц с:</span>
        <dx-select-box
          class="mb-2"
          v-model="filter.monthIdFrom"
          :data-source="monthsList"
          width="100%"
          value-expr="id"
          display-expr="name"
          :showClearButton="false"
          :disabled="filter.plFactId !== '2'"
          @valueChanged="reloadData()">
        </dx-select-box>
        <span>Вид энергии:</span>
        <dx-select-box
          v-model="filter.energyType"
          :data-source="energyTypeRadio"
          width="100%"
          value-expr="id"
          display-expr="name"
          :showClearButton="false"
          @valueChanged="reloadData()"/>
      </div>
    </template>
    <template #filterThirdTemplate>
      <div class="mr-4">
        <span>Месяц по:</span>
        <dx-select-box
          class="mb-2"
          v-model="filter.monthIdTo"
          :data-source="monthsList"
          width="100%"
          value-expr="id"
          display-expr="name"
          :showClearButton="false"
          :disabled="filter.plFactId !== '2'"
          @valueChanged="reloadData()"
        />
        <span>Вид деятельности:</span>
        <dx-select-box
          v-model="filter.viewMode"
          :data-source="viewModeList"
          width="100%"
          value-expr="id"
          display-expr="name"
          :showClearButton="false"
          @valueChanged="changeViewMode()"/>
      </div>
    </template>
    <template #filterRadioModeTemplate>
      <div class="d-flex align-items-end dropDownModuleHeight">
        <div class="mr-4">
          <span>Отчет по:</span>
          <dx-radio-group
            class="col-form-label"
            v-model="filter.mode"
            value-expr="id"
            display-expr="name"
            :dataSource="[{ id: '1', name: 'Подразделению' }, { id: '2', name: 'Статье затрат' }]"
            @value-changed="changeMode()"

          />
        </div>
        <div class="dropDownFilter">
          <ai-drop-down-tab
            v-if="filter.mode === '1'"
            ref="sprDepartmentComboRef"
            :columns="[{ caption: 'Наименование', dataField: 'name' }]"
            :get-data-source="getDsSprDepartmentsCombo"
            drop-down-width="400"
            key-expr="id"
            parent-id-expr="parent_id"
            valueExpr="name"
            placeholder="Подразделению:"
            selectionMode="single"
            :defaultValue="filter.departmentId"
            :displayPlaceholder="false"
            :chooseAll="false"
            :showClearButton="false"
            :showColumnHeaders="false"
            :show-filter-row="true"
            :validate-required="true"
            dropDownHeight="100%"
            @value-changed="changedFilter($event, 'departmentId')"
          ></ai-drop-down-tab>
          <ai-drop-down-tab
            v-if="filter.mode === '2'"
            ref="sprSmetComboRef"
            :columns="[{ caption: 'Наименование', dataField: 'name' }]"
            :get-data-source="getDsSprSmetCombo"
            drop-down-width="400"
            key-expr="id"
            parent-id-expr="parent_id"
            valueExpr="name"
            placeholder="Статье затрат:"
            selectionMode="single"
            :defaultValue="filter.kodSprSmetId"
            :chooseAll="false"
            :showClearButton="false"
            :showColumnHeaders="false"
            :show-filter-row="true"
            :validate-required="true"
            dropDownHeight="100%"
            @value-changed="changedFilter($event, 'kodSprSmetId')"
          ></ai-drop-down-tab>
        </div>
      </div>
    </template>
    <template #filterPrRoundTemplate>
      <div class="align-items-end d-flex mr-4 pb-2 dropDownModuleHeight">
        <dx-check-box
          v-model="filter.prRound"
          text="С округлением до тыс.руб"
          @value-changed="reloadData()"
        />
      </div>
    </template>
  </dx-tree-list>
  <footer-grid
    class="pr-1"
    :totalCount="totalCount"
    :showSelectedCounter="false"
  ></footer-grid>
</template>

<script>
export default {
  name: 'mped-report-results-view',
};
</script>

<script setup>
import { computed, onBeforeMount, ref, watch } from 'vue';
import {
  DxLoadPanel,
  DxScrolling,
  DxSelection,
  DxSorting,
  DxTreeList,
} from 'devextreme-vue/tree-list';
import { DxSelectBox, DxCheckBox } from 'devextreme-vue';
import DxRadioGroup from 'devextreme-vue/radio-group';

import {
  getAiToolbar,
} from '@/components/utils/ai-toolbar-generator';
import {
  expandTree,
  getAiDataSource,
} from '@/components/utils/ai-data-source-generator';
import {
  energyTypeRadio,
  plFactIdRadio,
  monthsList,
  viewModeList,
  getYearsList,
  getResultColumns,
  getSprSmetCombo,
  getSprDepartmentsCombo,
  getResultPlanFact,
  setRecalculateResults,
  getConfirmationResults,
  setConfirmationResults,
} from '@/views/mped/services/mped-estimate-service';
 import AiDropDownTab from '@/components/ai-drop-down-tab/ai-drop-down-tab.vue';
import { getUserData, setUserData } from '@/views/mped/services/mped-service';
import { useRouter } from 'vue-router';
import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import { svgAiLibrary } from '@/service/svg-ai-library';

const
  totalCount = ref(0),
  treeListRef = ref(),
  sprSmetComboRef = ref(),
  sprDepartmentComboRef = ref(),
  isExpand = ref(true),
  yearDataSource = ref(),
  buttonInstance = ref(),
  confirmationState = ref(),
  filter = ref({
    year: new Date().getFullYear(),
    monthIdFrom: 1,
    monthIdTo: 12,
    departmentId: null,
    kodSprSmetId: null,
    viewMode: '0',
    mode: '1',
    plFactId: '2',
    energyType: '0',
    prRound: true
  });

let columns;
let allIds = [];
let isAfterLoad = false;

const dataSource = getAiDataSource(
  {
    validationFn: () =>  filter.value.year && filter.value.viewMode && filter.value.energyType && filter.value.plFactId
      && (filter.value.departmentId || filter.value.kodSprSmetId)
      && ((filter.value.plFactId === '2' && filter.value.monthIdFrom && filter.value.monthIdTo) || filter.value.plFactId !== '2'),
    dataFn: getResultPlanFact,
    paramsFn: () => Object.assign({}, {
    ...filter.value, formaId: 3
    }),
    key: 'id',
    onLoadedFn: (result) => {
      isAfterLoad = true;
      totalCount.value = result.totalCount;
      allIds = result.data.map(x => filter.value.mode === '1' ? x.kod_spr_smet : x.kod_direct);
    },
  },
);

const router = useRouter();

const userDataKey = computed({
  get: () => router.currentRoute.value.name
});

watch(filter.value, () => {
  saveUserData();
});

const saveUserData = () => {
  if (userDataKey.value) {
    setUserData(userDataKey.value, filter.value);
  }
};

onBeforeMount(async () => {
  yearDataSource.value = getYearsList((new Date()).getFullYear(), 4, 4);
  if (userDataKey.value && getUserData(userDataKey.value))
    filter.value = getUserData(userDataKey.value);
  getColumns();
});

const changeViewMode = async () => {
  filter.value.kodSprSmetId = null;
  await changeValueAndFilter();
}

const changeValueAndFilter = async () => {
  if (filter.value.mode === '1')
    sprDepartmentComboRef.value.refreshData(await getDsSprDepartmentsCombo());
  else if (filter.value.mode === '2') {
    sprSmetComboRef.value.refreshData(await getDsSprSmetCombo());
  }

  await reloadData();
};

const getDsSprSmetCombo = async () => {
  return await getSprSmetCombo({ formaId: 3, year: filter.value.year, viewMode: filter.value.viewMode });
};

const getDsSprDepartmentsCombo = async () => {
  return await getSprDepartmentsCombo({ formaId: 3, year: filter.value.year, viewMode: filter.value.viewMode });
}

const getInstance = () => {
  return treeListRef.value.instance;
};

const reloadData = async () => {
  await dataSource.reload();
  await checkConfirmationStatus();
}

const reloadDataAndClearSort = () => {
  reloadData();
  treeListRef.value.instance.clearSorting();
}


const onContentReady = (e) => {
  if (isAfterLoad) {
    expandTree({
      ids: allIds,
      dxInstance: getInstance(),
    });
  }
  isAfterLoad = false;
};

const confVisible = computed(() => {
    if (filter.value.mode === '2') {
        return false;
    }
    return filter.value.plFactId !== '2';
});

const onToolbarPreparing = (e) => {
  e.toolbarOptions.elementAttr = {
    class: 'ai-toolbar-two-rows-with-label',
  };
  getAiToolbar(e, {
    customs: [
      {
        location: 'before',
        template: 'filterFirstTemplate',
      }, {
        location: 'before',
        template: 'filterSecondTemplate',
      }, {
        location: 'before',
        template: 'filterThirdTemplate',
      }, {
        location: 'before',
        template: 'filterRadioModeTemplate',
        options: {
          style: 'vertical-align: bottom',
        }
      }, {
        location: 'before',
        template: 'filterPrRoundTemplate',
      }, {
        location: 'after',
        locateInMenu: 'auto',
        after: 'refresh',
        widget: 'dxButton',
        cssClass: 'toolbar-item-custom-style',
        options: {
          onClick: () => {
            buttonRecalculate()
          },
          hint: 'Перерасчет',
            text: 'Перерасчет',
          icon: svgAiLibrary['ai-calculator-base'],
          style: 'vertical-align: bottom'
        }
      }, {
        location: 'after',
        locateInMenu: 'auto',
        widget: 'dxButton',
        options: {
          onClick: () => {
            buttonConfirmation(e.toolbarOptions)
          },
          onInitialized: (e) => {
            buttonInstance.value = e.component;
            changeConfirmationButtonStatus();
          },
          text: null,
          hint: null,
          icon: null,
          style: 'vertical-align: bottom',
        }
      }
    ],
    expand: {
      event: (e) => {
        isExpand.value = !isExpand.value;
        expandTree({
          ids: allIds,
          dxInstance: getInstance(),
          expand: isExpand.value
        });
      },
    },
    refresh: {
      event: (e) => {
       reloadDataAndClearSort();
      },
    },
  });
};

const onCellPrepared = (e) => {
  if (e.rowType === 'data') {
    const colId = e?.column?.dataField?.includes('qv') && 'qv' || e?.column?.dataField?.includes('pg') && 'pg'
      || e?.column?.dataField?.includes('9m') && 'm' || e?.column?.dataField?.includes('year') && 'year';
    const rowClassNameMap = {
      qv: 'text-primary',
      pg: 'text-success',
      m: 'text-secondary',
      year: 'text-danger',
    };
    e.cellElement.classList.add(rowClassNameMap[colId]);
  }
}

const getColumns = () => {
  columns = getResultColumns({ plFactId: filter.value.plFactId, mode: filter.value.mode })
};

const changeMode = () => {
  switch (filter.value.mode) {
    case '1': filter.value.kodSprSmetId = null;
      break;
    case '2': filter.value.departmentId = null;
      break;
  }
  changeVisibleColumns();
};

const changeVisibleColumns = () => {
  getColumns();
  treeListRef.value.instance.option('columns', columns);
  reloadData();
};

const changedFilter = (e, filed) => {
  if (e?.value) {
    filter.value[filed] = e.value;
  } else {
    filter.value[filed] = e;
  }
  reloadData();
};

const buttonRecalculate = async () => {
  if (confirm('Вы уверены, что хотите совершить перерасчет?')) {
    await setRecalculateResults({ params: {...filter.value, formaId: 3 }}).then(() => reloadData());
  }
}

const buttonConfirmation = async () => {
  if (confirmationState.value ? confirm('Вы уверены, что хотите снять утверждение итогов?') : confirm('Вы уверены, что хотите утвердить итоги?')) {
    await setConfirmationResults({ params: { ...filter.value, formaId: 3 }}).then(() => reloadData());
    changeConfirmationButtonStatus();
  }
}

const checkConfirmationStatus = async () => {
  const res = await getConfirmationResults({ params: { ...filter.value, formaId: 3 }});
  confirmationState.value = res.confirmation;
  changeConfirmationButtonStatus();
}

const changeConfirmationButtonStatus = () => {
  buttonInstance.value.option('text', confirmationState.value ? 'Утвержден' : 'Не утвержден');
  buttonInstance.value.option('hint', confirmationState.value ? 'Снять утверждение' : 'Утвердить');
  buttonInstance.value.option('icon', confirmationState.value ? svgAiLibrary['ai-choose-base'] : svgAiLibrary['ai-close-base']);
  buttonInstance.value.option('visible',  confVisible.value);
}
</script>

<style lang="scss" scoped>
.dropDownFilter {
  width: 300px;
}

.dropDownModuleHeight {
  height: 100%;
}
</style>
